import React from "react";

export const CandidateContext = React.createContext(null);
